<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-md-8 col-12 pl-md-5 pr-md-5">
          <div class="row">
            <div class="col-md-12 mb-3">
              <h5 class="text-uppercase">Informatietype aanmaken</h5>
            </div>
            <div class="col-md-12">
              <div class="form-group d-flex">
                <div class="circle">
                  <img
                    :src="
                      imagesrc
                        ? imagesrc
                        : 'https://www.pinclipart.com/picdir/big/322-3225911_gallery-icon-uniao-da-direita-clipart.png'
                    "
                  />
                </div>
                <div class="ml-4 mt-4">
                  <input
                    @change="readImage()"
                    type="file"
                    class="d-none"
                    id="itemtypefile"
                  />
                  <button class="btn btn-dark btn-sm">
                    <label class="p-0 m-0" for="itemtypefile">Upload</label>
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <label for="name">Naam</label>
                <input
                  v-model="itemtype.title"
                  type="text"
                  class="form-control"
                  id="name"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="textarea1">Omschrijving</label>
                <editor
                  id="textarea1"
                  v-model="itemtype.description"
                  :init="{
                    height: 200,
                    menubar: false,
                    language: 'nl',
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount',
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor | \
                                                            alignleft aligncenter alignright alignjustify | \
                                                            bullist numlist outdent indent | removeformat | help',
                  }"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-12 pl-md-2">
          <div class="row mb-3">
            <div class="col-md-12 col-12 mb-3 p-0">Selecteer informatie:</div>
            <div class="col-md-12 col-12 px-0">
              <!-- <select2itemgroups></select2itemgroups> -->
              <Multiselect
                mode="tags"
                v-model="selectedIGroups"
                :options="itemGroups"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-12 mb-3 p-0">
              Leden
              <Multiselect
                mode="tags"
                v-model="selectedMbrs"
                searchable
                :options="users"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-12 mb-3 p-0">
              Commissies
              <Multiselect
                searchable
                mode="tags"
                v-model="selectedICommittees"
                :options="allComs"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div
          style="justify-content: space-between"
          class="col-12 pl-md-5 pr-md-5 d-flex"
        >
          <label class="d-block" for="">Informatiegroepen:</label>
          <button
            class="d-block btn-dark"
            href="javascript:void(0)"
            @click="openInfoModal()"
          >
            <i class="fas fa-plus"></i>
          </button>
        </div>
        <div class="col-12 pl-md-5 pr-md-5">
          <draggable v-model="info_groups">
            <div
              v-for="(group, index) in info_groups"
              :key="'infogroup_' + index"
              class="infoGroup mt-2 list-group-item"
            >
              <div class="label">
                <i class="fas fa-bars"></i>
                <b class="ml-2">{{ group.title }}</b>
              </div> 
              <div
                class="group-tool"
              >
                <a
                  @click="openInfoModal(group, index)"
                  href="javascript:void(0)"
                >
                  <i class="fas fa-pencil-alt text-white mr-3"></i>
                </a>
                <a @click="removeInfoGroup(group.id)" href="javascript:void(0)">
                  <i class="fas fa-trash text-white"></i>
                </a>
              </div>
            </div>
          </draggable>
        </div>
        <div class="col-lg-12">
          <button @click="createItemtype()" class="btn-dark float-right mt-3">
            <span v-if="saving">aan het opslaan..</span>
            <span v-else>Opslaan</span>
          </button>
        </div>
      </div>
    </div>
    <!--        STRUCTURE Modal-->
    <div
      class="modal fade"
      id="structureModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row pr-5">
              <div class="col-md-7 col-12 px-md-5">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <h5 class="text-uppercase">Informatiegroep toevoegen</h5>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">Naam</label>
                      <input
                        v-model="info_group.title"
                        type="text"
                        class="form-control"
                        id="name"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="textareaGroup">Omschrijving</label>
                      <editor
                        id="textareaGroup"
                        v-model="info_group.description"
                        :init="{
                          height: 200,
                          menubar: false,
                          language: 'nl',
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                                                            alignleft aligncenter alignright alignjustify | \
                                                            bullist numlist outdent indent | removeformat | help',
                        }"
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <input
                      v-model="info_group.public"
                      id="publicGroup"
                      class="form-check-input ml-1 mt-1"
                      type="checkbox"
                      value=""
                    />
                    <label for="publicGroup" class="ml-4">Publiek</label>
                  </div>
                  <div class="col-6">
                    <input
                      v-model="info_group.multiple"
                      id="publicGroup"
                      class="form-check-input ml-1 mt-1"
                      type="checkbox"
                      value=""
                    />
                    <label for="publicGroup" class="ml-4">Meervoudig</label>
                  </div>
                </div>
              </div>
              <div class="col-md-5 col-12">
                <div class="row">
                  <div class="col-md-12 mb-3 px-0">
                    <h5 class="text-uppercase">Bewerkbaar door</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-12 px-0">
                    <div class="form-group">
                      <label for="name">Commissies</label>
                      <Multiselect
                        mode="tags"
                        v-model="info_group.committees"
                        searchable
                        :options="allComs"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-12 mb-3 p-0">
                    Leden
                    <Multiselect
                      mode="tags"
                      v-model="info_group.members"
                      searchable
                      :options="users"
                    />
                    <!-- <members
                      :group="clickedGroup"
                      action="addSelectedInfoGroupMembers"
                    ></members> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label for="">Maak de velden voor het itemtype</label>
              </div>
              <div class="col-12 container-bg">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Omschrijving</th>
                      <th>Veld</th>
                      <th></th>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-group">
                          <input
                            v-model="field.label"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <select
                            v-model="field.field"
                            name=""
                            id=""
                            class="form-control"
                          >
                            <option value="">Veldtype</option>
                            <option value="text">Text</option>
                            <option value="tinymce">Tekstvak</option>
                            <option value="file">Bestand</option>
                            <option value="image">Afbeelding</option>
                            <option value="select2">Dropdown</option>
                          </select>
                        </div>
                      </td>
                      <td>
                        <button @click="addField()" class="btn btn-dark btn-sm">
                          <i class="fa fa-plus"></i>
                        </button>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(field, index) in info_group.fields"
                      :key="'add_info_group_' + index"
                      class="field"
                    >
                      <td>{{ field.label }}</td>
                      <td>{{ field.field | getFieldLabel }}</td>
                      <td class="text-right">
                        <span class="mr-3">
                          <a
                            v-if="index != info_group.fields.length - 1"
                            @click="movedInfoGroupFields(index, index + 1)"
                            href="javascript:void(0)"
                            ><i class="fas fa-arrow-down text-white mr-2"></i
                          ></a>

                          <a
                            v-if="index != 0"
                            @click="movedInfoGroupFields(index, index - 1)"
                            href="javascript:void(0)"
                            ><i class="fas fa-arrow-up text-white"></i
                          ></a>
                        </span>
                        <a
                          @click="removeField(field.id)"
                          href="javascript:void(0)"
                          ><i class="fas fa-trash text-white"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-lg-12">
                <button
                  @click="createInfoGroup()"
                  class="btn-dark float-right mt-3"
                >
                  Opslaan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      drag: false,
      enabled: false,
      saving: false,
      create_itemtype: {
        active: false,
        public: false,
        parent_id: 0,
      },
      itemtype: {},
      imagesrc: null,
      info_groups: [],
      info_group: {
        title: "",
        description: "",
        multiple: false,
        public: false,
        committees: [],
        members: [],
        fields: [],
      },
      value: [],
      users: [],
      clickedGroup: null,
      clickedGroupIndex: null,
      field: { label: "", field: "" },
      selectedIGMembers: [],
      selectedMbrs: [],
      itemGroups: [],
      selectedIGroups: [],
      selectedICommittees: [],
      allComs: [],
      selectedComs: [],
      committees: [],
    };
  },
  async created() {
    await this.$store.dispatch("get", "api/v1/active/users").then((data) => {
      data.data.data.forEach((item) => {
        this.users.push({
          value: item.id,
          label: item.display_name,
          disabled: item.disabled,
        });
      });
    });

    await this.$store.dispatch("get", "api/v1/itemgroups").then((data) => { 
      data.data.data.forEach((item) => {
        this.itemGroups.push({
          value: item.id,
          label: item.title,
          disabled: item.disabled,
        });
      });
    });

    if (this.$route.params.id) {
      this.$store
        .dispatch("get", "api/v1/itemtypes/" + this.$route.params.id)
        .then((data) => {
          this.itemtype = data.data.data;
          this.info_groups = this.itemtype.structure;
          this.selectedMbrs = this.itemtype.members.map((item) => {
            return item.id;
          });

          this.selectedICommittees = this.itemtype.committees.map((item) => {
            return item.id;
          });

          this.selectedIGroups = this.itemtype.itemgroups.map((item) => {
            return item.id;
          });
        });
    }

    await this.$store
      .dispatch("get", "api/v1/committees/all/parent-id")
      .then((data) => {
        data.data.data.forEach((item) => {
          this.allComs.push({
            value: item.id,
            label: item.title,
            disabled: item.disabled,
          });
        });
      });
  },
  methods: {
    openInfoModal(group = null, index = null) {
      if (group != null) {
        this.info_group = { ...group };
        this.clickedGroup = group;
        this.clickedGroupIndex = index;
      } else {
        this.info_group = {
          title: "",
          description: "",
          multiple: false,
          public: false,
          committees: [],
          members: [],
          fields: [],
        };
        this.clickedGroup = null;
        this.clickedGroupIndex = null;
      }
      window.$("#structureModal").modal("show");
    },
    addField() {
      if (this.field.label.length == 0 || this.field.field.length == 0) {
        return false;
      }
      this.field.id = Math.round(Math.random() * 999);
      this.field.field_id = Math.round(Math.random() * 999);
      this.info_group.fields.unshift({ ...this.field });
      this.field.label = "";
      this.field.field = "";
    },
    removeField(id) {
      if (!window.confirm("Are you sure you want to delete this item?")) {
        return false;
      }
      this.info_group.fields = this.info_group.fields.filter((d) => d.id != id);
    },
    readImage() {
      var file = document.getElementById("itemtypefile").files[0];
      var fileReader = new FileReader();
      fileReader.onload = (data) => {
        this.imagesrc = data.currentTarget.result;
      };
      fileReader.readAsDataURL(file);
    },
    removeInfoGroup(id) {
      if (!window.confirm("Are you sure you want to delete this item?")) {
        return false;
      }
      this.info_groups = this.info_groups.filter((d) => d.id != id);
    },
    createInfoGroup() {
      if (this.info_group.title.length == 0) {
        return false;
      }
      if (this.clickedGroupIndex === null) {
        this.info_group.id = Math.round(Math.random() * 999);
        this.info_groups.unshift({ ...this.info_group });
      } else {
        this.info_groups[this.clickedGroupIndex] = this.info_group;
      }
      this.createItemtype();
      window.$("#structureModal").modal("hide");
    },

    createItemtype() {
      if (this.saving) return false;
      this.saving = true;

      this.itemtype.selected_members = JSON.stringify(this.selectedMbrs);
      this.itemtype.selected_itemgroups = JSON.stringify(this.selectedIGroups);
      this.itemtype.selected_committees = JSON.stringify(
        this.selectedICommittees
      );
      this.itemtype.structure = this.info_groups;


      if (this.imagesrc != null) {
        this.itemtype.image = this.imagesrc;
      }

      this.$store
        .dispatch(this.$route.params.id ? "put" : "post", {
          endpoint: this.$route.params.id
            ? "api/v1/itemtypes/" + this.$route.params.id
            : "api/v1/itemtypes",
          details: this.itemtype,
        })
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          this.saving = false;
        });
    },
    movedInfoGroupFields(from, to, on = 1) {
      (this.info_group.fields = this.info_group.fields.slice()),
        this.info_group.fields.splice(
          to,
          0,
          ...this.info_group.fields.splice(from, on)
        ),
        this.info_group.fields;
    },
  },
  filters: {
    getFieldLabel(val) {
      const nl = {
        text: "Text",
        tinymce: "Tekstvak",
        file: "Bestand",
        image: "Afbeelding",
        select2: "Dropdown",
      };

      return nl[val];
    },
  },
};
</script>

<style scoped>
.list-group-item:hover::after,
.active-item::after {
  display: block;
  content: none;
}
.circle img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 1px solid lightgray;
}
.infoGroup {
  background: #4192d9;
  justify-content: space-between;
  color: white;
  display: flex;
  padding: 10px 15px;
  border-radius: 10px;
}
.field {
  background: #4192d9;
  border-radius: 10px;
  color: white;
  margin-top: 5px !important;
}
</style>
